import React from 'react'

import SettingsIcon from 'karrierhub-ui/dist/common/src/svg/SettingsIcon'

function getMenu(props = {}) {

    const { appContext, type } = props
    const { menus } = appContext

    return [
        {
            label: menus.loginMenu,
            href: (p) => {
                return '/login' + (p.req?.query.redirect ? '?redirect=' + encodeURIComponent(p.req.query.redirect) : '')
            },
            role: function(p) {
                return !(p.user?._id)
            }
        },
        {
            label: menus.signupMenu,
            href: (p) => {
                return '/signup' + (p.req?.query.redirect ? '?redirect=' + encodeURIComponent(p.req.query.redirect) : '')
            },
            role: function(p) {
                return !(p.user?._id)
            }
        },
        {
            label: menus.accountSettingsMenu,
            href: '/settings',
            role: function(p) {
                if (!p.page || p.page === 'settings') {
                    return false
                }
                return p.user?._id && p.user._status_isNotDeleted
            },
            startIcon: <SettingsIcon />
        },
        {
            divider: true,
            role: function(p) {
                if (!p.page || p.page === 'settings') {
                    return false
                }
                return p.user?._id && p.user._status_isNotDeleted
            }
        },
        ...type === 'detailed' ? [
            {
                label: menus.changeData, href: '/changedata',
                role: function(p) {
                    return p.user?._id && p.user._status_isNotDeleted
                }
            },
            {
                label: menus.invoiceSettings, href: '/invoicesettings',
                role: function(p) {
                    return p.user?._id && p.user._status_isNotDeleted
                }
            },
            {
                label: menus.employeeSettings, href: '/employeesettings',
                role: function(p) {
                    return p.user?._id && p.user._status_isNotDeleted
                }
            },
            {
                label: menus.notificationSettings, href: '/notificationsettings',
                role: function(p) {
                    return p.user?._id && p.user._status_isNotDeleted
                }
            },
            {
                label: menus.changeEmail, href: '/changeemail',
                role: function(p) {
                    return p.user?._id && p.user._status_isNotDeleted
                }
            },
            {
                label: menus.emailConfirmation, href: '/emailconfirmation',
                role: function(p) {
                    return p.user?._id && !p.user?.emailConfirmed && p.user._status_isNotDeleted
                }
            },
            {
                label: menus.changePassword, href: '/changepassword',
                role: function(p) {
                    return p.user?._id && p.user._status_isNotDeleted
                }
            }
        ] : [
            {
                label: menus.profileSettings, href: '/profilesettings',
                role: function(p) {
                    return p.user?._id && p.user._status_isNotDeleted
                }
            },
            {
                label: menus.invoiceSettings, href: '/invoicesettings',
                role: function(p) {
                    return p.user?._id && p.user._status_isNotDeleted
                }
            },
            {
                label: menus.employeeSettings, href: '/employeesettings',
                role: function(p) {
                    return p.user?._id && p.user._status_isNotDeleted
                }
            },
            {
                label: menus.notificationSettings, href: '/notificationsettings',
                role: function(p) {
                    return p.user?._id && p.user._status_isNotDeleted
                }
            }
        ],
        ...type === 'detailed' ? [
            {
                label: menus.forgotPasswordMenu, href: '/forgotpassword',
                role: function(p) {
                    return (p.user && p.user._status_isNotDeleted) || !(p.user?._id)
                }
            },
            {
                label: menus.deleteAccount, href: '/deleteaccount',
                role: function(p) {
                    return p.user?._id && p.user._status_isNotDeleted
                }
            }
        ] : [
            {
                label: menus.otherSettings, href: '/othersettings',
                role: function(p) {
                    return p.user?._id && p.user._status_isNotDeleted
                }
            }
        ],
        {
            label: menus.logoutMenu, href: '/logout',
            role: function(p) {
                return p.user?._id
            }
        }
    ]

}

export default getMenu
